import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';

import styles from './GiftShowcaseItem.css';


const GiftShowcaseItem = (props) => {
  const {
    gift,
    handleBackClick,
    modal,
    onClickHandler,
  } = props;

  const onOpenGift = useCallback(() => {
    if (onClickHandler) {
      onClickHandler(gift);
    } else {
      ModalService.showModal(
        ModalService.MODAL_KEYS.SEND_USER_GIFT_MODAL,
        { gift, handleBackClick }
      );

      handleBackClick?.();
    }
  }, [
    gift,
    handleBackClick,
    onClickHandler,
  ]);

  const itemClasses = classNames({
    [styles.GiftShowcaseItem]: true,
    [styles.GiftModalItem]: modal,
  });

  const ttKey = gift?.ttKey;

  return (
    <div className={itemClasses} onClick={onOpenGift}>
      <div className={styles.giftWrapper}>
        <div className={styles.content}>
          <img
            alt={gift?.name}
            className={styles.showcaseImg}
            src={gift?.details?.imageUrl}
          />
          <div className={styles.giftInfo}>
            <p className={styles.giftName}>
              {translate(`gifting.${ttKey}`, {}, gift.name)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

GiftShowcaseItem.propTypes = {
  gift: PropTypes.object.isRequired,
  handleBackClick: PropTypes.func,
  modal: PropTypes.bool,
  onClickHandler: PropTypes.func,
};

GiftShowcaseItem.defaultProps = {
  handleBackClick: undefined,
  modal: false,
  onClickHandler: undefined,
};

export default observer(GiftShowcaseItem);
